import { action, reaction, observable } from 'mobx';

import * as LOCALES from '../data/locales';

import uiStore from './ui';

class Intl {
    constructor() {
        this.setDictionary();
        reaction(
            () => uiStore.locale,
            () => this.setDictionary(),
        )
    }

    @observable
    dictionary = {}

    @action
    setDictionary() {
        const {locale} = uiStore;
        this.dictionary = LOCALES[locale] || {};
    }
}

export default new Intl();
